module.exports = __webpack_public_path__ + "img/select-type__02.df548206.png";